<div
  class="body ui container fluid"
  fxLayout="column"
  fxLayoutAlign="flex-start none"
>
<div class="breadcrumb">
  <div class="breadcrumb-itself">
    <div class="left">
      <div>
          <img src="assets/icons/left-arrow-icon.svg" alt=""  (click)="goBack()"/>
        </div>
  </div>
  <div class="right">
      <div class="top">
          <h4>Home / Settings / Application Security</h4>
      </div>
      <div class="bottom">
          <h2 class="ui primary header">Logs</h2>
      </div>
  </div>
  </div>
</div>
  <div class="ui divider" appMargin marginY="3"></div>

  <div class="body ui container" fxLayout="column" style="margin: 0; border: none !important; width: 100%;">
    <div class="ui divider" appMargin marginY="3" style="border: none !important;"></div>
    <div *ngIf="success || error">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <app-advanced-search-filter
      (onDisplayRows)="displayRecords($event)"
      (onSearch)="searchRecords($event)"
      [hasAdvancedSearch]="true"
      [headers]="headers"
      [headerFilters]="headerFilters"
      [hasFilters]="true"
      (onSort)="sortRecords($event)"
      [searchFilters]="searchFilter"
      (advancedSearch)="advancedSearch($event)"
      (cancelAd)="cancelAd()"
    ></app-advanced-search-filter>
  
    <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
      <div
        fxLayout="row"
        tamsyMargin
        class="ui segment"
        marginB="3"
        fxLayoutGap="10px"
        fxLayoutAlign="start stretch"
        id="dark"
      >
        <div fxFlex="20%">Request URLs</div>
        <div fxFlex="15%">Request Method</div>
        <div fxFlex="15%">Timestamp</div>
        <div fxFlex="15%">IP Address</div>
        <div fxFlex="10%">Response status code</div>
        <div fxFlex="15%">Response Time</div>
        <div fxFlex="10%">Blacklist</div>
      </div>

      <app-logs-row *ngFor="let log of logs" [log]="log" (reload)="reload()" (success)="onSuccess($event)"></app-logs-row>
  
      <app-no-record-found
        *ngIf="logs && logs.length < 1"
      ></app-no-record-found>
      <app-no-record-found *ngIf="!logs"></app-no-record-found>
      
      <div class="ui vertical basic segment">
        <div class="ui two column grid">
          <div class="column middle aligned">
            <div class="ui icon button" (click)="getPage(1)">
              <i class="database icon"></i>
            </div>
            <a class="ui basic label">{{ totalItems }} Record(s)</a>
          </div>
          <div
            class="column right aligned pagination menu"
            style="margin-left: auto"
          >
            <sui-pagination
              class="small"
              [collectionSize]="totalItems"
              [pageSize]="rows"
              [maxSize]="maxSize"
              [hasEllipses]="false"
              [page]="currentPage"
              (pageChange)="nextPage($event)"
            >
            </sui-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>
